import { OCCUPANCY_CARD_TYPE } from 'src/features/cards/types';
import { cardMessages } from 'src/features/cards/utils/messages';

const TOTAL_SPACES_NAME = 'TOTAL';

const datetimeFormatOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
};

const OCCUPANCY_CARD_TYPE_MAP = {
    [OCCUPANCY_CARD_TYPE.NORMAL]: cardMessages.cardTypeNormal,
    [OCCUPANCY_CARD_TYPE.VIP]: cardMessages.cardTypeVip,
    [OCCUPANCY_CARD_TYPE.PREPAID]: cardMessages.cardTypePrepaid,
    [OCCUPANCY_CARD_TYPE.ALL]: cardMessages.cardTypeAll,
};

const CANVAS_SHORT_WIDTH = 300;
const CANVAS_LONG_WIDTH = 386;
const CANVAS_LINE_HEIGHT = 18;

export {
    TOTAL_SPACES_NAME,
    datetimeFormatOptions,
    CANVAS_LINE_HEIGHT,
    CANVAS_LONG_WIDTH,
    CANVAS_SHORT_WIDTH,
    OCCUPANCY_CARD_TYPE_MAP,
};
